import {defineMessage} from 'react-intl';
import html from './web/js/html';
import css from './web/js/css';
import js from './web/js/js';
import webSteps from './web/steps';
import ruby, {steps as rubySteps} from './server/ruby';
import python, {steps as pythonSteps} from './server/python';
import node, {steps as nodeSteps} from './server/node';
import php, {steps as phpSteps} from './server/php';
import java, {steps as javaSteps} from './server/java';
import go, {steps as goSteps} from './server/go';
import dotnet, {steps as dotnetSteps} from './server/dotnet';
import phpCreate from './server/php-create';
import phpCapture from './server/php-capture';
import esnext from './web/esnext/js';
import objcM from './ios/objc/objc-m';
import objcH from './ios/objc/objc-h';
import apiClientM from './ios/objc/apiclient-m';
import apiClientH from './ios/objc/apiclient-h';
import swift from './ios/swift/swift';
import swiftApi from './ios/swift/swiftApi';
import iosSteps from './ios/steps';
import kotlinGradle from './android/kotlin/gradle';
import javaGradle from './android/java/gradle';
import kotlin from './android/kotlin/kotlin';
import kotlinReader from './android/kotlin/kotlinReader';
import kotlinBackend from './android/kotlin/kotlinBackend';
import kotlinToken from './android/kotlin/kotlinToken';
import kotlinApi from './android/kotlin/kotlinApi';
import kotlinExample from './android/kotlin/kotlinExample';
import kotlinEvent from './android/kotlin/kotlinEvent';
import kotlinBluetooth from './android/kotlin/kotlinBluetooth';
import kotlinConnectionToken from './android/kotlin/kotlinConnectionToken';
import kotlinPaymentIntent from './android/kotlin/kotlinPaymentIntent';
import javaclient from './android/java/javaclient';
import javaclientReaderAdapter from './android/java/javaclientReaderAdapter';
import javaclientReaderHolder from './android/java/javaclientReaderHolder';
import javaclientReaderListener from './android/java/javaclientReaderListener';
import javaclientBackend from './android/java/javaclientBackend';
import javaclientToken from './android/java/javaclientToken';
import javaclientApi from './android/java/javaclientApi';
import javaclientExample from './android/java/javaclientExample';
import javaclientConnectionToken from './android/java/javaclientConnectionToken';
import javaclientPaymentIntent from './android/java/javaclientPaymentIntent';
import javaclientEvent from './android/java/javaclientEvent';
import javaclientBluetooth from './android/java/javaclientBluetooth';
import androidSteps from './android/steps';
import xml from './android/xml';
import xmlReader from './android/xmlReader';
import xmlManifest from './android/xmlManifest';
import docs from './build';

export const sections = [
  {
    id: 'setup-server',
    heading: {
      message: defineMessage({
        id: 'docsApp.ib.terminal.sections.setup-server',
        defaultMessage: 'Set up the server',
      }),
    },
    active: true,
  },
  {
    id: 'setup-sdk',
    heading: {
      message: defineMessage({
        id: 'docsApp.ib.terminal.sections.setup-sdk',
        defaultMessage: 'Set up the SDK',
      }),
    },
    active: true,
  },
  {
    id: 'reader',
    heading: {
      message: defineMessage({
        id: 'docsApp.ib.terminal.sections.reader',
        defaultMessage: 'Connect to the simulated reader',
      }),
    },
    active: true,
  },
  {
    id: 'collect-payment',
    heading: {
      message: defineMessage({
        id: 'docsApp.ib.terminal.sections.collect-payment',
        defaultMessage: 'Collecting Payments',
      }),
    },
  },
  {
    id: 'test-the-integration',
    heading: {
      message: defineMessage({
        id: 'docsApp.ib.terminal.sections.test-the-integration',
        defaultMessage: 'Test the integration',
      }),
    },
  },
];

export const integrations = {
  docs,
  javascript: {
    steps: webSteps,
    files: {
      html: {
        builder: html,
        language: 'html',
        name: 'public/index.html',
      },
      js: {builder: js, language: 'js', name: 'public/client.js'},
      css: {builder: css, language: 'css', name: 'public/global.css'},
    },
  },
  esnext: {
    steps: webSteps,
    files: {
      html: {
        builder: html,
        language: 'html',
        name: 'public/index.html',
      },
      js: {builder: esnext, language: 'js', name: 'public/client.js'},
      css: {builder: css, language: 'css', name: 'public/global.css'},
    },
  },
  swift: {
    files: {
      swift: {
        builder: swift,
        language: 'swift',
        name: 'ViewController.swift',
      },
      swiftApi: {
        builder: swiftApi,
        language: 'swift',
        name: 'APIClient.swift',
      },
    },
    steps: iosSteps,
  },
  objc: {
    files: {
      objcM: {
        builder: objcM,
        language: 'objectivec',
        name: 'ViewController.m',
      },
      objcH: {
        builder: objcH,
        language: 'objectivec',
        name: 'ViewController.h',
      },
      apiClientM: {
        builder: apiClientM,
        language: 'objectivec',
        name: 'APIClient.m',
      },
      apiClientH: {
        builder: apiClientH,
        language: 'objectivec',
        name: 'APIClient.h',
      },
    },
    steps: iosSteps,
  },
  kotlin: {
    files: {
      kotlin: {
        builder: kotlin,
        language: 'java',
        name: 'MainActivity.kt',
      },
      kotlinToken: {
        builder: kotlinToken,
        language: 'java',
        name: 'TokenProvider.kt',
      },
      kotlinExample: {
        builder: kotlinExample,
        language: 'java',
        name: 'StripeTerminalApplication.kt',
      },
      kotlinReader: {
        builder: kotlinReader,
        language: 'java',
        name: 'ReaderRecyclerView.kt',
      },
      kotlinApi: {
        builder: kotlinApi,
        language: 'java',
        name: 'ApiClient.kt',
      },
      kotlinBackend: {
        builder: kotlinBackend,
        language: 'java',
        name: 'BackendService.kt',
      },
      kotlinEvent: {
        builder: kotlinEvent,
        language: 'java',
        name: 'TerminalEventListener.kt',
      },
      kotlinBluetooth: {
        builder: kotlinBluetooth,
        language: 'java',
        name: 'TerminalBluetoothReaderLister.kt',
      },
      kotlinConnectionToken: {
        builder: kotlinConnectionToken,
        language: 'java',
        name: 'ConnectionToken.kt',
      },
      kotlinPaymentIntent: {
        builder: kotlinPaymentIntent,
        language: 'java',
        name: 'ServerPaymentIntent.kt',
        filter: (options) => ['wpe'].includes(options.reader),
      },
      xmlManifest: {
        builder: xmlManifest,
        language: 'xml',
        name: 'AndroidManifest.xml',
      },
      gradle: {
        builder: kotlinGradle,
        language: 'groovy',
        name: 'build.gradle',
      },
      xml: {
        builder: xml,
        language: 'xml',
        name: 'activity_main.xml',
      },
      xmlReader: {
        builder: xmlReader,
        language: 'xml',
        name: 'list_item_reader.xml',
      },
    },
    steps: androidSteps,
  },
  javaclient: {
    files: {
      javaclient: {
        builder: javaclient,
        language: 'java',
        name: 'MainActivity.java',
      },
      javaclientToken: {
        builder: javaclientToken,
        language: 'java',
        name: 'TokenProvider.java',
      },
      javaclientExample: {
        builder: javaclientExample,
        language: 'java',
        name: 'StripeTerminalApplication.java',
      },
      javaclientReaderListener: {
        builder: javaclientReaderListener,
        language: 'java',
        name: 'ReaderClickListener.java',
      },
      javaclientApi: {
        builder: javaclientApi,
        language: 'java',
        name: 'ApiClient.java',
      },
      javaclientReaderHolder: {
        builder: javaclientReaderHolder,
        language: 'java',
        name: 'ReaderHolder.java',
      },
      javaclientReaderAdapter: {
        builder: javaclientReaderAdapter,
        language: 'java',
        name: 'ReaderAdapter.java',
      },
      javaclientBackend: {
        builder: javaclientBackend,
        language: 'java',
        name: 'BackendService.java',
      },
      javaclientConnectionToken: {
        builder: javaclientConnectionToken,
        language: 'java',
        name: 'ConnectionToken.java',
      },
      javaclientPaymentIntent: {
        builder: javaclientPaymentIntent,
        language: 'java',
        name: 'ServerPaymentIntent.java',
        filter: (options) => ['wpe'].includes(options.reader),
      },
      javaclientEvent: {
        builder: javaclientEvent,
        language: 'java',
        name: 'TerminalEventListener.java',
      },
      javaclientBluetooth: {
        builder: javaclientBluetooth,
        language: 'java',
        name: 'TerminalBluetoothReaderListener.java',
      },
      xmlManifest: {
        builder: xmlManifest,
        language: 'xml',
        name: 'AndroidManifest.xml',
      },
      gradle: {
        builder: javaGradle,
        language: 'groovy',
        name: 'build.gradle',
      },
      xml: {
        builder: xml,
        language: 'xml',
        name: 'activity_main.xml',
      },
      xmlReader: {
        builder: xmlReader,
        language: 'xml',
        name: 'list_item_reader.xml',
      },
    },
    steps: androidSteps,
  },
  ruby: {
    files: {
      ruby: {
        builder: ruby,
        language: 'ruby',
        name: 'server.rb',
      },
    },
    steps: rubySteps,
  },
  node: {
    files: {
      node: {
        builder: node,
        language: 'js',
        name: 'server.js',
      },
    },
    steps: nodeSteps,
  },
  python: {
    files: {
      python: {
        builder: python,
        language: 'python',
        name: 'server.py',
      },
    },
    steps: pythonSteps,
  },
  php: {
    files: {
      php: {
        builder: php,
        language: 'php',
        name: 'token.php',
      },
      phpCreate: {
        builder: phpCreate,
        language: 'php',
        name: 'create.php',
        filter: (options) => ['wpe'].includes(options.reader),
      },
      phpCapture: {
        builder: phpCapture,
        language: 'php',
        name: 'capture.php',
      },
    },
    steps: phpSteps,
  },
  java: {
    files: {
      java: {
        builder: java,
        language: 'java',
        name: 'src/com/stripe/sample/Server.java',
      },
    },
    steps: javaSteps,
  },
  go: {
    files: {
      go: {
        builder: go,
        language: 'go',
        name: 'server.go',
      },
    },
    steps: goSteps,
  },
  dotnet: {
    files: {
      dotnet: {
        builder: dotnet,
        language: 'dotnet',
        name: 'Server.cs',
      },
    },
    steps: dotnetSteps,
  },
};

export default {
  integrations,
  sections,
};
